// copy to vben-admin

const toString = Object.prototype.toString

export const is = (val: unknown, type: string) => {
  return toString.call(val) === `[object ${type}]`
}

export const isDef = <T = unknown>(val?: T): val is T => {
  return typeof val !== 'undefined'
}

export const isUnDef = <T = unknown>(val?: T): val is T => {
  return !isDef(val)
}

export const isObject = (val: any): val is Record<any, any> => {
  return val !== null && is(val, 'Object')
}

export const isEmpty = <T = unknown>(val: T): val is T => {
  if (isArray(val) || isString(val)) {
    return val.length === 0
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0
  }

  if (isNull(val)) {
    return true
  }

  return false
}

export const isDate = (val: unknown): val is Date => {
  return is(val, 'Date')
}

export const isNaN = (val: any) => {
  return Number.isNaN(val) ? true : false
}

export const isNull = (val: unknown): val is null => {
  return val === null
}

export const isNullAndUnDef = (val: unknown): val is null | undefined => {
  return isUnDef(val) && isNull(val)
}

export const isNullOrUnDef = (val: unknown): val is null | undefined => {
  return isUnDef(val) || isNull(val)
}

export const isNumber = (val: unknown): val is number => {
  return is(val, 'Number')
}

export const isNumberPlus = (val: any) => {
  return /^\d+$/.test(val)
}

export const isPromise = <T = any>(val: unknown): val is Promise<T> => {
  return is(val, 'Promise') && isObject(val) && isFunction(val.then) && isFunction(val.catch)
}

export const isString = (val: unknown): val is string => {
  return is(val, 'String')
}

export const isFunction = (val: unknown): val is Function => {
  return typeof val === 'function'
}

export const isBoolean = (val: unknown): val is boolean => {
  return is(val, 'Boolean')
}

export const isRegExp = (val: unknown): val is RegExp => {
  return is(val, 'RegExp')
}

export const isArray = (val: any): val is Array<any> => {
  return val && Array.isArray(val)
}

export const isWindow = (val: any): val is Window => {
  return typeof window !== 'undefined' && is(val, 'Window')
}

export const isElement = (val: unknown): val is Element => {
  return isObject(val) && !!val.tagName
}

export const isMap = (val: unknown): val is Map<any, any> => {
  return is(val, 'Map')
}

export const isServer = typeof window === 'undefined'

export const isClient = !isServer

export const isUrl = (path: string): boolean => {
  const reg =
    /(((^https?:(?:\/\/)?)(?:[-:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&%@.\w_]*)#?(?:[\w]*))?)$/
  return reg.test(path)
}

export const isDark = (): boolean => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

// 是否是图片链接
export const isImgPath = (path: string): boolean => {
  return /(https?:\/\/|data:image\/).*?\.(png|jpg|jpeg|gif|svg|webp|ico)/gi.test(path)
}

export const isEmptyVal = (val: any): boolean => {
  return val === '' || val === null || val === undefined
}

/**判断是否在微信小程序内 */
export const isWxMiniProgram = () => {
  const ua: any = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger') && ua.includes('miniprogram')
}

// 是否在微信浏览器内
export const isWxBrowser = (s: any = 0) => {
  const ua: any = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}

// 判断当前是PC/H5
export const _isMobile = (s: any = 0) => {
  //console.log('navigator',navigator);
  const flag =
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|X11)/i.test(
      navigator.userAgent
    )
  return flag || isWxMiniProgram() ? true : false
}

// 判断当前是苹果
export const _isIos = () => {
  const flag =
    /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  return flag ? true : false
}

// 判断当前使用设备是否为安卓
export const _isAndroid = () => {
  return /Android/.test(navigator.userAgent)
}

// 判断当前使用设备是否为windows
export const _isWindows = () => {
  return /Windows/.test(navigator.userAgent)
}

// 判断当前使用设备是否为mac
export const _isMac = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}

// 获取当前用户操作设备
export const getSystem = () => {
  if (_isIos()) {
    return 'ios'
  } else if (_isAndroid()) {
    return 'android'
  } else if (_isWindows()) {
    return 'windows'
  } else if (_isMac()) {
    return 'mac'
  } else {
    return 'other'
  }
}

// 获取当前浏览器类型
export const getBrowser = () => {
  var Sys: any = {}
  var ua = navigator.userAgent.toLowerCase()
  var s
  ;(s = ua.match(/edg\/([\d.]+)/))
    ? (Sys.edg = s[1])
    : (s = ua.match(/qqbrowser.([\d.]+)/))
      ? (Sys.QQ = s[1])
      : (s = ua.match(/ucbrowser.([\d.]+)/))
        ? (Sys.UC = s[1])
        : (s = ua.match(/metasr.([\d.]+)/))
          ? (Sys.SG = s[1])
          : (s = ua.match(/baidu.([\d.]+)/))
            ? (Sys.BAIDU = s[1])
            : (s = ua.match(/360se/))
              ? (Sys.NUM = s[0])
              : (s = ua.match(/micromessenger.([\d.]+)/))
                ? (Sys.WX = s[1])
                : (s = ua.match(/firefox\/([\d.]+)/))
                  ? (Sys.firefox = s[1])
                  : (s = ua.match(/chrome\/([\d.]+)/))
                    ? (Sys.chrome = s[1])
                    : (s = ua.match(/opera.([\d.]+)/))
                      ? (Sys.opera = s[1])
                      : (s = ua.match(/version\/([\d.]+).*safari/))
                        ? (Sys.safari = s[1])
                        : 0
  //以下进行测试
  if (Sys.edg) return 'Edge'
  if (Sys.firefox) return 'Firefox'
  if (Sys.chrome) return 'Chrome'
  if (Sys.opera) return 'Opera'
  if (Sys.safari) return 'Safari'
  if (Sys.QQ) return 'QQ'
  if (Sys.UC) return 'UC'
  if (Sys.SG) return 'SG'
  if (Sys.NUM) return '360'
  if (Sys.BAIDU) return 'BAIDU'
  if (Sys.WX) return 'WX'
}

/**
 * 判断是否为JSON类型
 * @param val
 * @returns
 */
export const isJSON = (val: any) => {
  try {
    JSON.parse(val)
    return true
  } catch (e) {
    return false
  }
}

/**判断当前富文本是否为空 */
export const isEditorEmpty = (richText: any) => {
  // 创建一个临时的DOM元素
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = richText

  // 获取所有文本节点
  const textNodes = tempDiv.querySelectorAll('*')
  const visibleText = Array.from(textNodes)
    .map((node: any) => node.textContent.trim())
    .join('')

  // 获取所有图片和链接
  const images = tempDiv.querySelectorAll('img')
  const links = tempDiv.querySelectorAll('a')

  // 判断是否只有图片或链接
  return visibleText === '' && images.length === 0 && links.length === 0
}

/** 判断是否为小程序短链 */
export const isMiniProgramLink = url => {
  const pattern = /^#小程序:\/\/([\u4e00-\u9fa5a-zA-Z0-9_-]+)\/([a-zA-Z0-9_-]+)$/
  return pattern.test(url)
}
